/**
 * @generated SignedSource<<e1f9f0d87989006ec9cf0f19759a0c63>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TVDashboardPickerButton_dashboards$data = ReadonlyArray<{
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"TVDashboardPickerPopoverDashboards">;
  readonly " $fragmentType": "TVDashboardPickerButton_dashboards";
}>;
export type TVDashboardPickerButton_dashboards$key = ReadonlyArray<{
  readonly " $data"?: TVDashboardPickerButton_dashboards$data;
  readonly " $fragmentSpreads": FragmentRefs<"TVDashboardPickerButton_dashboards">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "TVDashboardPickerButton_dashboards",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TVDashboardPickerPopoverDashboards"
    }
  ],
  "type": "Dashboard",
  "abstractKey": null
};

(node as any).hash = "af9d9013b1e80446ea6807dd11133b21";

export default node;
